module.exports = __webpack_public_path__ + "static/bride-car-a1e543aefe8ad63be5c6089bdcc1018e.svg";